<template>
  <div>
    <b-row>
      <b-col class="col-12 col-sm-12 text-center text-sm-left p-0 pt-0 pt-sm-1 pt-md-2 pt-lg-3">
        <b-img
                :src=logoUrl alt="logo" class="imgLogo"></b-img>
        <div class="titleBx" style="padding-top: 37px;float: left;margin-left: 10px;">
          <span class="customTitle" style="bottom:0px;">New Medicare Application</span>
        </div>
      </b-col>

    </b-row>

  </div>
</template>
<script>
export default {
  name: "CustomTitle",
  components: {

  },
  data() {
    return {
      logoUrl: '',
      imgBxHeight: 0,
      previewFlag: false
    };
  },
  props: {
    form: Object,
    showprint: Boolean,
    relncodes: Array
  },
  async created() {
    if(process.env.VUE_APP_CLIENT){
      this.logoUrl = window.location.origin+'/images/logos/'+process.env.VUE_APP_CLIENT+'.png';
    }else{
      this.logoUrl = window.location.origin+'/images/logos/default.png';
    }

  },
  methods: {
    async generateReport () {
      this.previewFlag = true;
      await this.$refs.html2Pdf.generatePdf();
      this.previewFlag = false;
    }
  }

};
</script>
<style scoped>
  .customTitle{
    color: #5A5C5E;
    font-weight: 600;
    font-size: 20pt;
    margin: 0;
    border-left: 2px solid #ccc;
    padding-left:10px;
  }
  .titleBx{
    padding-top: 37px;float: left;margin-left: 10px;
  }
  .imgLogo {
    float: left;
    height: 113px;
  }

  @media screen and (max-width: 520px) {
    .customTitle{
      border: none !important;
    }
    .titleBx{
      float: none !important;
      padding-top: 10px !important;
    }
    .imgLogo{
      float: none !important;
    }
  }
</style>
